(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCarouselJobList', sodCarouselJobList);

    function sodCarouselJobList($rootScope, lodash) {
        return {
            restrict: 'E',
            scope: { options: '=' },
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return attrs.template;
                }

                return 'common/components/sod-carousel-job-list';
            },
            controller: sodCarouselJobListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: sodCarouselJobListLink,
        };

        function sodCarouselJobListLink(scope, elem, attr) {
            scope.$watch(function() {
                return elem.attr('sod-slick-child');
            }, function(newValue) {
                scope.vm.sodSlickInitEvent = ['sod-slick', newValue, 'init'].join('.')
                $rootScope.$broadcast(scope.vm.sodSlickInitEvent);
            });
        }

        function sodCarouselJobListCtrl(GenericModel, $scope) {
            var vm = this;

            this.$onInit = function() {
                init();
            }

            function init() {
                vm.featuredJobs = [];
                callRemoteApi(lodash.get(vm, 'options.datasource.list', {}))
                    .then(function (res) {
                        vm.featuredJobs = res || [];
                        $rootScope.$broadcast(vm.sodSlickInitEvent, 600);
                    });

                $scope.$watch(function() {
                    return vm.featuredJobs;
                }, function(newValue) {
                    if (lodash.isEmpty(vm.featuredJobs)) {
                        $('#featured-jobs').hide();
                    } else {
                        $('#featured-jobs').show();
                    }
                });
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return lodash.get(res, 'rows', []);
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();